import styled from 'styled-components'

const MainControlsWrapper = styled('div')`
  display: flex;
  align-items: baseline;
`

export default MainControlsWrapper
